<div class="dialog-container">

  <div class="dialog-header">
    <div class="flex items-center gap-2">
      <span class="dialog-title">Validação Logística</span>
      @if (!loading && validacao) {
        @if (validacao.compativel) {
          <span class="badge-green">Compatível</span>
        } @else {
          <span class="badge-red">Incompatível</span>
        }
      }
    </div>
    <div class="flex items-center gap-2">
      <button mat-button class="btn-tg" (click)="load()" [disabled]="loading">
        @if (loading) { Carregando... } @else { Verificar novamente }
      </button>
      <button class="btn-icon" (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="dialog-body">

    @if (loading) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }

    @if (!loading && validacaoError) {
      <div class="empty-state">
        <mat-icon style="color:#b00101">error_outline</mat-icon>
        <p>Não foi possível carregar a validação. Tente novamente.</p>
      </div>
    }

    @if (!loading && validacao) {

      <!-- Discrepâncias de Quantidade -->
      <div class="section-card">
        <span class="section-title">
          Discrepâncias de Quantidade
          @if ((validacao.discrepanciasQuantidade?.length ?? 0) === 0) {
            <span class="badge-green">OK</span>
          } @else {
            <span class="badge-red">{{ validacao.discrepanciasQuantidade?.length }} problema(s)</span>
          }
        </span>

        @if ((validacao.discrepanciasQuantidade?.length ?? 0) > 0) {
          <table-list-simple
            [dataSource]="validacao.discrepanciasQuantidade"
            [columns]="quantidadeColumns"
          />
        } @else {
          <p class="no-issues">Nenhuma discrepância de quantidade encontrada.</p>
        }
      </div>

      <!-- Discrepâncias de Trecho -->
      <div class="section-card">
        <span class="section-title">
          Discrepâncias de Trecho
          @if ((validacao.discrepanciasTrecho?.length ?? 0) === 0) {
            <span class="badge-green">OK</span>
          } @else {
            <span class="badge-red">{{ validacao.discrepanciasTrecho?.length }} problema(s)</span>
          }
        </span>

        @if ((validacao.discrepanciasTrecho?.length ?? 0) > 0) {
          <table-list-simple
            [dataSource]="validacao.discrepanciasTrecho"
            [columns]="trechoColumns"
          />
        } @else {
          <p class="no-issues">Nenhuma discrepância de trecho encontrada.</p>
        }
      </div>

      <!-- Discrepâncias de Rota -->
      <div class="section-card">
        <span class="section-title">
          Discrepâncias de Rota
          @if ((validacao.discrepanciasRota?.length ?? 0) === 0) {
            <span class="badge-green">OK</span>
          } @else {
            <span class="badge-red">{{ validacao.discrepanciasRota?.length }} problema(s)</span>
          }
        </span>

        @if ((validacao.discrepanciasRota?.length ?? 0) > 0) {
          <table-list-simple
            [dataSource]="validacao.discrepanciasRota"
            [columns]="rotaColumns"
          />
        } @else {
          <p class="no-issues">Nenhuma discrepância de rota encontrada.</p>
        }
      </div>

    }

  </div>
</div>
